import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    name: "Consultation",
    desc: "Tell us what you want. We look at your vehicle, your budget, and how you actually use it.",
  },
  {
    n: "02",
    name: "Design Plan",
    desc: "We map out your build — components, enclosure design, wiring plan, and fitment.",
  },
  {
    n: "03",
    name: "Installation",
    desc: "Precision work, clean execution. Solder-sealed connections and hidden wiring, every time.",
  },
  {
    n: "04",
    name: "Final Walkthrough",
    desc: "Full system demo and tuning. You leave smiling — and probably turn it up on the way out.",
  },
];

export default function Process() {
  return (
    <section id="process" className="relative py-24 sm:py-36 bg-[#0D0F14] border-y border-white/5" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <Eyebrow>The Process</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            How It <span className="text-[#FF5500]">Works</span>
          </h2>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="h-full">
              <div
                data-testid={`process-step-${i}`}
                className="group h-full rounded-2xl border border-white/10 bg-[#12141B] p-7 transition-all duration-500 hover:-translate-y-2 hover:border-[#FF5500]/50"
              >
                <p className="font-tech text-sm text-[#FF5500] tracking-[0.3em]">{s.n}</p>
                <div className="my-5 h-px w-full bg-white/10 transition-colors duration-500 group-hover:bg-[#FF5500]/60" />
                <h3 className="font-display text-xl font-bold tracking-tight">{s.name}</h3>
                <p className="mt-3 text-sm text-white/60 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
